import { formatMoney } from 'accounting-js';

export const formattedAmount = amount => {
  return formatMoney(amount, {
    symbol: '₮',
    format: '%v %s',
    precision: 0
  });
};
